export const FIRST_TAB_VALUE: string = '1';
export const SECOND_TAB_VALUE: string = '2';
export const THIRD_TAB_VALUE: string = '3';
export const DEFAULT_ITEMS_NUMBER: number = 40;
